// extracted by mini-css-extract-plugin
export default {"grid-container":"Indicators_grid-container__7+gKh","grid-item":"Indicators_grid-item__K0+37"};